export default __webpack_public_path__ + "static/outsource-dce08841bc9468886ebad0ef49378ecd.webp";